import padStart from 'lodash/padStart'

export const formatTime = (fullTime: number) => {
  const time = Math.round(fullTime)
  let hours = 0
  let minutes = 0
  let seconds = 0

  if (time >= 3600) {
    hours = Math.floor(time / 3600)
  }

  if (time - hours * 3600 >= 60) {
    minutes = Math.floor((time - hours * 3600) / 60)
  }

  seconds = time - (hours * 3600 + minutes * 60)

  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`
  }

  if (minutes > 0) {
    return `${minutes}m ${seconds}s`
  }

  return `${seconds}s`
}

export const formatCurrency = (value: number) => {
  if (value < 1e3) return value
  if (value < 1e6) return `${(value / 1e3).toFixed(1)}K`
  if (value < 1e9) return `${(value / 1e6).toFixed(1)}M`
  if (value < 1e12) return `${(value / 1e9).toFixed(1)}G`
  return `${Math.floor(value / 1e12)}T`
}

function addCommas(number: number) {
  const value = `${Math.trunc(number)}`
  const helper = []
  const { length } = value

  if (number < 1e3) return value

  if (number < 1e6) {
    helper.push(value.slice(-3))
    helper.push(value.slice(0, length - 3))
    return `${helper[1]},${helper[0]}`
  }

  if (number < 1e9) {
    helper.push(value.slice(-3))
    helper.push(value.slice(-6, -3))
    helper.push(value.slice(0, length - 6))
    return `${helper[2]},${helper[1]},${helper[0]}`
  }

  if (number < 1e12) {
    helper.push(value.slice(-3))
    helper.push(value.slice(-6, -3))
    helper.push(value.slice(-9, -6))
    helper.push(value.slice(0, length - 9))
    return `${helper[3]},${helper[2]},${helper[1]},${helper[0]}`
  }
  helper.push(value.slice(-3))
  helper.push(value.slice(-6, -3))
  helper.push(value.slice(-9, -6))
  helper.push(value.slice(-12, -9))
  helper.push(value.slice(0, length - 12))
  return `${helper[4]},${helper[3]},${helper[2]},${helper[1]},${helper[0]}`
}

export const formatWithCommas = (number: number) => {
  let fraction = (number - Math.floor(number)).toFixed(2)
  if (+fraction === 0) {
    return addCommas(number)
  }

  fraction += ''
  fraction = fraction.slice(1)
  return addCommas(number) + fraction
}

const SI_SYMBOLS = ['', 'k', 'M', 'G', 'T', 'P', 'E']

export const nFormatter = (number: number, minDigits = 1, maxDigits = 1) => {
  if (!number || number === 0) return number

  const tier = Math.floor(Math.log10(Math.abs(number)) / 3)

  if (tier === 0) return number

  const suffix = SI_SYMBOLS[tier]
  const scale = 10 ** (tier * 3)

  const scaled = number / scale

  return (
    scaled.toLocaleString(undefined, {
      minimumFractionDigits: minDigits,
      maximumFractionDigits: maxDigits
    }) + suffix
  )
}

export const formatSeconds = (secs: number) => {
  const days = Math.max(0, Math.floor(secs / 60 / 60 / 24))

  const divisor_for_hours = secs % (60 * 60 * 24)
  const hours = Math.max(0, Math.floor(divisor_for_hours / (60 * 60)))

  const divisor_for_minutes = secs % (60 * 60)
  const minutes = Math.max(0, Math.floor(divisor_for_minutes / 60))

  const divisor_for_seconds = divisor_for_minutes % 60
  const seconds = Math.max(0, Math.ceil(divisor_for_seconds))

  return {
    days: padStart(days.toString(), 2, '0'),
    hours: padStart(hours.toString(), 2, '0'),
    minutes: padStart(minutes.toString(), 2, '0'),
    seconds: padStart(seconds.toString(), 2, '0'),
    totalSeconds: Math.max(0, secs)
  }
}
